import { render, staticRenderFns } from "./journals_archive.vue?vue&type=template&id=6acbb28f"
import script from "./journals_archive.vue?vue&type=script&lang=js"
export * from "./journals_archive.vue?vue&type=script&lang=js"
import style0 from "./journals_archive.vue?vue&type=style&index=0&id=6acbb28f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports